export default __webpack_public_path__ + "static/media/ohmyfood.b405a97c.jpg";